import * as tslib_1 from "tslib";
var BaseModel = /** @class */ (function () {
    function BaseModel() {
    }
    /**
     * Check if current class instance has all required fields
     *
     * @since 1.0.0
     */
    BaseModel.prototype.isValid = function () {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(this.requiredFields), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (this.get(key) === undefined || this.get(key) === null) {
                    console.warn('undefined or null', key);
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return true;
    };
    /**
     * Set given value for property with given key inside current model instance
     *
     * @todo: support dot notation like in the getter
     *
     * @since 1.0.0
     */
    BaseModel.prototype.set = function (key, value) {
        if (!this.hasOwnProperty(key)) {
            return false;
        }
        this[key] = value;
        return true;
    };
    /**
     * Get property with given key in current model instance
     * NB: supports dot notation like get('user.address.city');
     *
     * @since 1.0.0
     */
    BaseModel.prototype.get = function (key) {
        return key.split('.').reduce(function (a, b) { return a ? a[b] : undefined; }, this);
    };
    /**
     * Get model id
     *
     * @since 1.0.0
     */
    BaseModel.prototype.getId = function () {
        return this.get('_id');
    };
    /**
     * Get all private properties data and return them as object
     *
     * @since 1.0.0
     */
    BaseModel.prototype.getData = function () {
        var _this = this;
        var data = {};
        Object.keys(this).forEach(function (key) {
            data[key] = _this.get(key);
        });
        return data;
    };
    /**
     * Set given data to all private properties (if match)
     * and returns true if everything goes right, false
     * otherwise
     *
     * @since 1.0.0
     */
    BaseModel.prototype.setData = function (data) {
        var _this = this;
        if (data === null || data === undefined) {
            return undefined;
        }
        Object.keys(data).forEach(function (key) {
            if (_this.hasOwnProperty(key)) {
                _this.set(key, data[key]);
            }
            else {
                return undefined;
            }
        });
        return this.getData();
    };
    /**
     * Get the list of required fields
     *
     * @since 1.0.0
     */
    BaseModel.prototype.getRequiredFields = function () {
        return this.requiredFields;
    };
    /**
     * Set given data as required fields
     *
     * @since 1.0.0
     */
    BaseModel.prototype.setRequiredFields = function (data) {
        this.requiredFields = data;
    };
    return BaseModel;
}());
export { BaseModel };
